import { render } from "./AppSideMenu.vue?vue&type=template&id=e56ff924"
import script from "./AppSideMenu.vue?vue&type=script&lang=js"
export * from "./AppSideMenu.vue?vue&type=script&lang=js"

import "./AppSideMenu.vue?vue&type=style&index=0&id=e56ff924&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__